import { makeStyles } from "@mui/styles";

export const stylePopoverFilter = makeStyles(() => ({
  container: {
    padding: "12px 6px 0 6px",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  title: {
    display: "flex",
    justifyContent: "space-between",
    margin: "12px 0",

    "& .span-time": {
      fontSize: "14px",
      color: "#4B4B4B",
      fontWeight: "700",
    },

    "& .span-delete": {
      fontSize: "14px",
      color: "#0B7CE4",
      fontWeight: "400",
    },
  },

  time: {
    marginTop: "16px",
    paddingBottom: "16px",
    borderBottom: "1px solid #D4D4D4",

    "& .box-date": {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "14px",

      "& .from-date": {
        width: "49%",
      },
      "& .to-date": {
        width: "49%",
      },
    },

    "& .sapn-date": {
      marginBottom: "6px",
    },
  },

  box_check: {
    marginTop: "16px",
    paddingBottom: "16px",
    borderBottom: "1px solid #D4D4D4",
  },

  date: {
    "& .MuiInputBase-root": {
      paddingLeft: "4px",
    },

    "& .MuiInputBase-input": {
      padding: "6px 4px",
      fontSize: "13px",
    },

    "& .MuiButtonBase-root": {
      padding: "6px",

      "& .MuiSvgIcon-root": {
        width: "20px",
      },
    },
  },

  checkBox: {
    marginRight: "12px",
  },

  //
}));
